export const BRAND_PHOTOS = {
  front: '/brand/front.webp',
  angle: '/brand/angle.webp',
  counter: '/brand/counter.webp',
  dining: '/brand/dining.webp',
};

export const AW_LOGO = 'https://customer-assets.emergentagent.com/job_resto-oversight/artifacts/215jxmio_Corp_ArrowLogo_Bear_2C_HL_EN_Lg.png';

const ROTATION = [BRAND_PHOTOS.front, BRAND_PHOTOS.angle, BRAND_PHOTOS.counter, BRAND_PHOTOS.dining];

export const storePhoto = (index) => ROTATION[index % ROTATION.length];
